
import { Vue, Component, Watch } from 'vue-property-decorator';
// import Uploader from '@/components/next/Uploader.vue';
import Uploader from '../components/NewUploader.vue';
import qs from 'qs';
import { save, ifSave, getRule, getBaseInfo } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { FileType } from '@/common/ts/enum';
import {
  Field,
  Cell,
  CellGroup,
  Toast,
  Calendar,
  Picker,
  TreeSelect,
  RadioGroup,
  Radio,
} from 'vant';
Vue.use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Picker)
  .use(TreeSelect)
  .use(Calendar)
  .use(RadioGroup)
  .use(Radio);
@Component({
  components: {
    Uploader,
  },
})
export default class Save extends Vue {
  get uploadTip() {
    if (this.uploadFileType === FileType.Video) {
      return '视频大小最高不超过500M，仅支持mp4格式';
    }
    return '图片大小最低不低于1M-5M,画种不限（板绘要求精度不低于300分辨率）; 上传图片1-12张。';
  }
  workType = 1;
  workCategory: string = '摄影作品';
  showWorkCategoryPicker: boolean = false;
  workCategoryList: string[] = ['摄影作品', '视频作品'];
  uploadFileType: FileType = FileType.Image;
  FileType = FileType;
  submitting = false;
  uploaderKey = 0;

  name: string = '';
  phone: string = '';
  title: string = '';
  address: string = '';
  stime: string = '';
  introduction: string = '';
  imgSrc: any = [];
  unionid: string | null = '';
  minDate: Date = new Date(1970, 0, 1);
  maxDate: Date = new Date(2099, 0, 31);
  save: boolean = false;
  show: boolean = false;
  downLoadUrl: string =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  districts: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  selectedDistrict = '';
  showPicker = false;
  bannerImg: string = '';
  schoolName: string = '';
  teacherName: string = '';
  rulecontent: any = '';
  baseInfo: any = {};

  @Watch('workCategory')
  onWorkCategoryChange(val: string) {
    if (val === '视频作品') {
      this.uploadFileType = FileType.Video;
      this.workType = 1;
    } else {
      this.uploadFileType = FileType.Image;
    }
  }

  async uploadImg() {
    // 上传作品（图片或视频）
    let uploadRes: string[] = [];
    if (this.uploadFileType === FileType.Video) {
      // 视频作品：必须有 videoUploader
      if (this.$refs.videoUploader) {
        uploadRes = (await (
          this.$refs.videoUploader as Uploader
        ).uploadToOss()) as string[];
      }
    } else {
      // 绘画作品：必须有 imageUploader
      if (this.$refs.imageUploader) {
        uploadRes = (await (
          this.$refs.imageUploader as Uploader
        ).uploadToOss()) as string[];
      }
    }

    // 如果是视频作品，还需要上传封面
    let coverRes: string[] = [];
    if (this.uploadFileType === FileType.Video && this.$refs.coverUploader) {
      coverRes = (await (
        this.$refs.coverUploader as Uploader
      ).uploadToOss()) as string[];
    }

    // 组合结果
    if (this.uploadFileType === FileType.Video) {
      // 视频作品：视频链接|封面链接
      if (
        uploadRes &&
        uploadRes.length > 0 &&
        coverRes &&
        coverRes.length > 0
      ) {
        this.imgSrc = [uploadRes[0], coverRes[0]];
      } else {
        this.imgSrc = []; // 上传失败或未完成
      }
    } else {
      // 绘画作品：直接是图片链接数组
      this.imgSrc = uploadRes;
    }
  }

  async uploadCover() {
    if (this.$refs.coverUploader) {
      const res = (await (
        this.$refs.coverUploader as Uploader
      ).uploadToOss()) as string[];
      if (res && res.length > 0) {
        if (this.imgSrc.length < 2) {
          if (this.imgSrc.length === 0) this.imgSrc = ['', ''];
          else if (this.imgSrc.length === 1) this.imgSrc.push('');
        }
        this.$set(this.imgSrc, 1, res[0]);
        Toast('封面上传成功');
      }
    }
  }

  async uploadVideo() {
    if (this.$refs.videoUploader) {
      const res = (await (
        this.$refs.videoUploader as Uploader
      ).uploadToOss()) as string[];
      if (res && res.length > 0) {
        if (this.imgSrc.length < 2) {
          if (this.imgSrc.length === 0) this.imgSrc = ['', ''];
          else if (this.imgSrc.length === 1) this.imgSrc.push('');
        }
        this.$set(this.imgSrc, 0, res[0]);
        Toast('视频上传成功');
      }
    }
  }

  triggerUpload(refName: string) {
    const uploader = this.$refs[refName] as any;
    if (uploader && uploader.triggerUpload) {
      uploader.triggerUpload();
    }
  }

  async mounted() {
    const ret = await getRule();
    this.rulecontent = ret.data;
    const ret1 = await getBaseInfo();
    this.baseInfo = ret1.data;
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    const data = {
      unionid: this.unionid,
      token: window.gettoken(),
      appkey: window.appkey,
      wdid: window.udid,
    };
    const res: any = await ifSave(data);
    if (res.code === 200) {
      this.save = true;
    }
  }
  setType(type: number) {
    this.workType = type;
  }
  toggleWorkCategoryPicker() {
    this.showWorkCategoryPicker = !this.showWorkCategoryPicker;
  }
  onConfirmWorkCategory(value: string) {
    this.workCategory = value;
    this.toggleWorkCategoryPicker();
  }
  formatDate(date: any) {
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async onConfirm(d: string, i: number) {
    this.selectedDistrict = d;
    this.togglePicker();
  }
  onCancel() {
    this.togglePicker();
  }
  togglePicker() {
    this.showPicker = !this.showPicker;
  }

  dateOnConfirm(date: any) {
    this.show = false;
    this.stime = this.formatDate(date);
  }

  clearForm() {
    this.name = '';
    this.phone = '';
    this.title = '';
    this.introduction = '';
    this.schoolName = '';
    this.teacherName = '';
    this.selectedDistrict = '';
    this.imgSrc = [];
    this.uploaderKey++;
  }

  async submit() {
    if (this.submitting) return;

    if (!isWeiXin() && !window.udid) {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行报名',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
        });
      return;
    } else if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!this.phone) {
      Toast('请填写电话！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.title) {
      Toast('请填写作品名称！');
      return false;
    } else if (!this.introduction) {
      Toast('请填写简介！');
      return false;
    } else if (
      this.uploadFileType === FileType.Video &&
      this.imgSrc.length !== 2
    ) {
      Toast('请上传视频和封面！');
      return false;
    } else if (!this.imgSrc.length) {
      Toast('请上传图片！');
      return false;
    } else {
      this.submitting = true;
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0,
      });

      try {
        const data: any = {
          name: this.name,
          phone: this.phone,
          title: this.title,
          address: this.address,
          stime: this.stime,
          workType: this.uploadFileType === FileType.Image ? 1 : 2,
          introduction: this.introduction,
          unionid: this.unionid,
          token: window.token,
          appkey: window.appkey,
          udid: window.udid,
        };
        if (this.uploadFileType === FileType.Video) {
          data.video = this.imgSrc[0];
          data.cover = this.imgSrc[1];
        } else {
          data.cover = this.imgSrc.join('|');
        }
        const res: any = await save(data);
        Toast.clear();
        if (res.code === 200) {
          Toast(`${res.msg}`);
          this.clearForm();
          this.$router.push(`user`);
        } else {
          if (res.code === 505) {
            localStorage.removeItem('unionid');
            window.location.reload();
          } else {
            Toast(`${res.msg}`);
          }
        }
      } catch (error) {
        Toast.clear();
        Toast('网络错误，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
}
